import React from "react";
import { connect } from "react-redux";
import "./_RingSelectButton.scss";
import { toggleRingSelectModal } from "../../redux/actions";

class RingSelectButton extends React.Component {
  renderSelections = () => {
    const {
      selectRingButtonText,
      selectRingImageURL,
      selectHolderRingButtonText,
      selectHolderRingImageURL,
    } = this.props;
    if (this.props.mainRing) {
      return (
        <>
          <img
            className="ring-select-image"
            src={selectRingImageURL}
            alt="Main ring"
          />
          <button
            onClick={() => this.props.toggleRingSelectModal(true)}
            className="rounded-button"
          >
            {selectRingButtonText}
          </button>
        </>
      );
    } else {
      return (
        <>
          <img
            className="ring-select-image"
            src={selectHolderRingImageURL}
            alt="Holder ring"
          />
          <button
            onClick={() => this.props.toggleRingSelectModal(false)}
            className="rounded-button"
          >
            {selectHolderRingButtonText}
          </button>
        </>
      );
    }
  };

  render() {
    return <div className="ring-select-button">{this.renderSelections()}</div>;
  }
}

const mapStateToProps = ({ configuratorPage }) => {
  const {
    selectRingButtonText,
    selectRingImageURL,
    selectHolderRingButtonText,
    selectHolderRingImageURL,
  } = configuratorPage;

  return {
    selectRingButtonText,
    selectRingImageURL,
    selectHolderRingButtonText,
    selectHolderRingImageURL,
  };
};

export default connect(mapStateToProps, { toggleRingSelectModal })(
  RingSelectButton
);
